/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-expressions */

import React, { useCallback, useState } from 'react';
import { FaTrash, FaUtensils } from 'react-icons/fa';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { toast } from 'react-hot-toast';

import PersonalButton from '~/components/Buttons/PersonalButton';

import api from '~/services/api';
import {
  Divider,
  IconArrowFoward,
  IconChevronDown,
  IconPencil,
  IconTrash,
} from 'takeat-design-system-ui-kit';
import {
  Card,
  ChooseKitchenCard,
  LinkStyled,
  KdsArea,
  KdsOperationalArea,
  KdsContent,
  KdsOperationalContent,
  KdsOperationalTitle,
  KdsOperationalHeader,
  KdsOperacionalItems,
  ModalStyled,
} from './styles';
import EditKitchen from '../Kitchen/EditKitchen';

function ChooseKitchen({ kds, getKds }) {
  const [isModalDeleteOpened, setIsModalDeleteOpened] = useState(false);
  const [kdsIdToDelete, setKdsIdToDelete] = useState();

  const handleDeleteKds = useCallback(async () => {
    try {
      await api.delete(`/restaurants/kds/${kdsIdToDelete}`);
      toast.success('Tela deletada com suceso!');
      setIsModalDeleteOpened(false);

      getKds();
    } catch (error) {
      toast.error('Erro ao deletar tela');
    }
  }, [kdsIdToDelete, getKds]);

  const toggleDeleteKdsModal = useCallback(
    (id) => {
      setIsModalDeleteOpened(!isModalDeleteOpened);
      setKdsIdToDelete(id);
    },
    [isModalDeleteOpened]
  );

  const [kdsExpanded, setKdsExpanded] = useState([]);

  function handleExpandedKds(id) {
    setKdsExpanded((prevState) => {
      if (prevState.includes(id)) {
        return prevState.filter((item) => item !== id);
      }
      return [...prevState, id];
    });
  }

  const [kdsState, setKdsState] = useState();
  const [modalEditKitchen, setModalEditKitchen] = useState(false);

  function toggleModalEditKitchen() {
    setModalEditKitchen(!modalEditKitchen);
  }

  return (
    <Card>
      {kds &&
        kds?.length > 0 &&
        kds?.filter((item) => item?.kds_steps?.length === 0).length > 0 && (
          <>
            <KdsArea>
              <KdsContent>
                {kds &&
                  kds?.length > 0 &&
                  kds
                    ?.filter((item) => item?.kds_steps?.length === 0)
                    .map((item, index) => (
                      <ChooseKitchenCard key={item.id}>
                        <LinkStyled
                          to={{
                            pathname: '/kitchen',
                            state: {
                              item,
                              kds_index: index,
                            },
                          }}
                        >
                          <FaUtensils size="24" color="#fff" />{' '}
                          <p>{item?.name}</p>{' '}
                        </LinkStyled>

                        <FaTrash
                          color="#fff"
                          size={17}
                          title="Deletar tela"
                          onClick={() => {
                            toggleDeleteKdsModal(item.id);
                          }}
                          cursor="pointer"
                          style={{ position: 'absolute', top: 8, right: 8 }}
                        />
                      </ChooseKitchenCard>
                    ))}
              </KdsContent>
            </KdsArea>
            <Divider style={{ marginTop: 20, marginBottom: 10 }} />
          </>
        )}

      {kds &&
        kds?.length > 0 &&
        kds?.filter((item) => item.kds_steps?.length > 1).length > 0 && (
          <KdsOperationalArea>
            <KdsOperationalContent
              style={{
                gap: 8,
              }}
            >
              {kds &&
                kds?.length > 0 &&
                kds
                  ?.filter((item) => item.kds_steps?.length > 1)
                  .map((kds_item) => (
                    <>
                      <div
                        key={kds_item.id}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <KdsOperationalHeader>
                          <IconChevronDown
                            style={{
                              cursor: 'pointer',
                              fontSize: 24,
                              transform: kdsExpanded.includes(kds_item.id)
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)',
                            }}
                            fill="#545454"
                            onClick={() => {
                              handleExpandedKds(kds_item.id);
                            }}
                          />
                          <KdsOperationalTitle
                            onClick={() => {
                              handleExpandedKds(kds_item.id);
                            }}
                          >
                            {kds_item.name}
                          </KdsOperationalTitle>
                          <IconPencil
                            style={{
                              fontSize: 24,
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              setKdsState(kds_item);
                              toggleModalEditKitchen();
                            }}
                            fill="#545454"
                          />
                          <IconTrash
                            style={{
                              fontSize: 24,
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              toggleDeleteKdsModal(kds_item.id);
                            }}
                            fill="#C8131B"
                          />
                        </KdsOperationalHeader>

                        <KdsContent style={{ gap: 0 }}>
                          {kds_item.kds_steps.map(
                            (step, index, filteredArray) => (
                              <KdsOperacionalItems
                                isExpanded={!kdsExpanded.includes(kds_item.id)}
                                isOperational
                                key={step.id}
                              >
                                <ChooseKitchenCard
                                  key={kds_item.id}
                                  style={{ background: ' #01AFFF' }}
                                >
                                  <LinkStyled
                                    to={{
                                      pathname: '/kitchen',
                                      state: {
                                        item: {
                                          ...step,
                                          group_items: kds_item.group_items,
                                        },
                                        kds_index: index,
                                      },
                                    }}
                                  >
                                    <FaUtensils size="24" color="#fff" />{' '}
                                    <p>{step?.name}</p>{' '}
                                  </LinkStyled>
                                </ChooseKitchenCard>
                                {index < filteredArray.length - 1 && (
                                  <IconArrowFoward
                                    style={{
                                      alignSelf: 'center',
                                      fontSize: 24,
                                      margin: 8,
                                    }}
                                    fill="#222"
                                  />
                                )}
                              </KdsOperacionalItems>
                            )
                          )}
                        </KdsContent>
                      </div>

                      <Divider style={{ marginTop: 10 }} />
                    </>
                  ))}
            </KdsOperationalContent>
          </KdsOperationalArea>
        )}

      <Modal
        isOpen={isModalDeleteOpened}
        toggle={() => setIsModalDeleteOpened(false)}
      >
        <ModalBody>Tem certeza que deseja deletar essa tela?</ModalBody>
        <ModalFooter>
          <PersonalButton
            color="#FF2C3A"
            message="Cancelar"
            type="button"
            onClick={() => setIsModalDeleteOpened(false)}
          />
          <PersonalButton
            color="#0CCAB4"
            message="Confirmar"
            type="button"
            onClick={handleDeleteKds}
          />
        </ModalFooter>
      </Modal>

      <ModalStyled toggle={toggleModalEditKitchen} isOpen={modalEditKitchen}>
        <EditKitchen
          toggleModalEditKitchen={toggleModalEditKitchen}
          kdsState={kdsState}
        />
      </ModalStyled>
    </Card>
  );
}

export default ChooseKitchen;
